import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { CookiesProvider } from "react-cookie";
import { Auth0Provider } from "@auth0/auth0-react";
import TagManager from "react-gtm-module";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://6334b0894de834385c650418191a2163@o4509879420387328.ingest.us.sentry.io/4509879950770176",
  sendDefaultPii: true,
});

const tagManagerArgs = {
  gtmId: "GTM-WNGMZTK",
};

TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Sentry.ErrorBoundary fallback={<div>An error has occurred</div>}>
    <Auth0Provider
      domain="conciergecw.au.auth0.com"
      clientId="Zrt3z3oWoogTV3KOF3bsY9FSolMM8Vi7"
      redirectUri={window.location.origin}
    >
      <CookiesProvider>
        <App />
      </CookiesProvider>
    </Auth0Provider>
  </Sentry.ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
